import React, { useState, useEffect } from "react";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Modal from "react-bootstrap/Modal";
import { toast } from "react-toastify";

const EditLoan = ({ loan, onClose }) => {
  const [loanName, setLoanName] = useState(loan ? loan.loanName : "");
  const [loanCode, setLoanCode] = useState(loan ? loan.loanCode : "");
  const [intrestRateId, setIntrestRateId] = useState(
    loan && loan.intrestRateId ? loan.intrestRateId._id : ""
  );
  const [intrestRates, setIntrestRates] = useState([]);
  const [errors, setErrors] = useState({});
  const Api = process.env.REACT_APP_API;

  useEffect(() => {
    const fetchIntrestRates = async () => {
      try {
        const response = await fetch(`${Api}/api/intrest-rates`);
        const data = await response.json();
        setIntrestRates(data.intrestRates);
      } catch (error) {
        console.error("Error fetching interest rates:", error);
      }
    };

    fetchIntrestRates();
  }, []);

  const validateForm = () => {
    const newErrors = {};
    if (!loanName) {
      newErrors.loanName = "Loan name is required";
    }
    if (!loanCode) {
      newErrors.loanCode = "Loan Type is required";
    }
    if (!intrestRateId) {
      newErrors.intrestRateId = "Please select Interest Rate";
    }
    return newErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formErrors = validateForm();
    if (Object.keys(formErrors).length > 0) {
      setErrors(formErrors);
      toast.error("Please fill all details");
      return;
    }

    const formData = { loanName, loanCode, intrestRateId };

    try {
      const response = await fetch(`${Api}/api/loan-types/${loan._id}`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });
      if (response.ok) {
        const result = await response.json();
        console.log("Success:", result);
        toast.success("Submitted Successfully");

        onClose(); // Close the popup after successful form submission
      } else {
        console.error("Error submitting form:", response.statusText);
        toast.error("Error submitting form");
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      toast.error("Error submitting form");
    }
  };

  return (
    <div>
      <div className="page-header">
        <h3 className="page-title"> Edit Loan Type </h3>
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <a href="!#" onClick={(event) => event.preventDefault()}>
                VFC
              </a>
            </li>
            <li className="breadcrumb-item active" aria-current="page">
              Edit Loan Type
            </li>
          </ol>
        </nav>
      </div>
      <Modal show onHide={onClose}>
        <Modal.Header>
          <Modal.Title>Edit Loan</Modal.Title>
          <Button
            variant="outline-danger"
            onClick={onClose}
            style={{ marginLeft: "auto" }}
          >
            X
          </Button>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleSubmit}>
            <Form.Group controlId="formLoanName">
              <Form.Label>Loan Name</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter Loan name"
                value={loanName}
                onChange={(e) => setLoanName(e.target.value)}
                isInvalid={!!errors.loanName}
              />
              <Form.Control.Feedback type="invalid">
                {errors.loanName}
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group controlId="formLoanCode">
              <Form.Label>Loan Type</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter Loan code"
                value={loanCode}
                onChange={(e) => setLoanCode(e.target.value)}
                isInvalid={!!errors.loanCode}
              />
              <Form.Control.Feedback type="invalid">
                {errors.loanCode}
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group controlId="formIntrestRateId">
              <Form.Label>Interest Rate</Form.Label>
              <Form.Control
                as="select"
                value={intrestRateId}
                onChange={(e) => setIntrestRateId(e.target.value)}
                isInvalid={!!errors.intrestRateId}
              >
                <option value="">Select Interest Rate</option>
                {intrestRates.map((rate) => (
                  <option key={rate._id} value={rate._id}>
                    {rate.intrestName}
                  </option>
                ))}
              </Form.Control>
              <Form.Control.Feedback type="invalid">
                {errors.intrestRateId}
              </Form.Control.Feedback>
            </Form.Group>
          </Form>
          <Button type="submit">Submit</Button>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default EditLoan;
